import Vue from 'vue'
import Vuex from 'vuex'

import {
  CHGMEMODATA
} from './m-types'

import {screen} from './screen'
import {fmcInputs} from './fmcInputs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentStatus: {
      location: '',
      memoData: {
        warning: [],
        caution: ['NAV OUT OF DATA'],
        input: ''
      },
    },
    theme: {
      custFontSize: '',
      frameBgc: '',
      funArea: '',
      screen: '',
      bgcLight: '',
    },
    planeStatus: {
      fmcOutFirst: {
        transferRelay: {
          out: {
            asa: {
              
            },
            cdu: {
              
            },
            cds: {
              modeAnnc:{
                
              },
              rcp: {
                autotuneData: {
                  
                }
              },
              dme: {
                autotuneData: {
                  
                }
              },
              dfcs: {
                steeringCmd: {
                  
                }
              },
              autoThrottle: {
                thrustCmd: {
                  
                }
              },
              smyd: {
                gw: {
                  
                }
              },
              fdau: {
                posData: {
                  
                }
              },
              gpwc: {
                trkAndPresentPos: {
                  
                }
              },
              dataLoader: {
                
              },
              fqpu: {
                biteData: {
                  
                }
              }
            }
          }
        }
      },
      fmcOutSecond: {
        cds: {
          displayData: {
            
          }
        },
        adiru: {
          navData: {
            
          }
        }
      }
    }
  },
  mutations: {
    [CHGMEMODATA](state, newMemo){
      state.currentStatus.memoData = newMemo
    }
  },
  actions: {
  },
  modules: {
    screen: screen,
    fmcInputs: fmcInputs
  }
})
